// filepath: src/services/inventoryServices.js
import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api/admin`,
});

/**
 * Fetch all products with inventory
 */
export const getInventory = async (token, branchId = "") => {
    if (!token) throw new Error("JWT token missing.");

    try {
        const response = await api.get("/inventory", {
            headers: { Authorization: `Bearer ${token}` },
            params: branchId ? { branch_id: branchId } : undefined,
        });

        return Array.isArray(response.data) ? response.data : [];
    } catch (err) {
        console.error("Error fetching inventory:", err.response?.data || err.message);
        throw new Error(err.response?.data?.message || "Failed to fetch inventory.");
    }
};

/**
 * Update inventory quantity
 */
export const updateInventory = async (productId, quantityChange, token, branchId = "") => {
    if (!token) throw new Error("JWT token missing.");

    try {
        const response = await api.put(
            `/inventory/${productId}`,
            { quantityChange },
            {
                headers: { Authorization: `Bearer ${token}` },
                params: branchId ? { branch_id: branchId } : undefined,
            }
        );

        return response.data;
    } catch (err) {
        console.error("Error updating inventory:", err.response?.data || err.message);
        throw new Error(err.response?.data?.message || "Failed to update inventory.");
    }
};
